import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 47.0078,
			width: 66,
			height: 35,
			fill: "#63688B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.75,
			y: 31.3125,
			width: 30.7325,
			height: 12.3784,
			fill: "#63688B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.1641,
			y: 36.0078,
			width: 3.41472,
			height: 3.41472,
			rx: 1.70736,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.4375,
			y: 36.0078,
			width: 20.4883,
			height: 3.41472,
			rx: 1.70736,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_9976_2259",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 66,
			y: 42,
			width: 23,
			height: 27,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M73.6991 65.0355C69.8209 61.8978 67.0186 55.6438 66.6562 50.0547L68.6409 42.8398L88.0717 43.561C88.6605 51.0732 89.4848 67.3227 88.0717 68.3324C86.3052 69.5944 78.6533 69.0438 73.6991 65.0355Z",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_9976_2259)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 23.1328,
				y: 44.6445,
				width: 63.9944,
				height: 29.2075,
				fill: "#9499B6"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.0703,
			y: 55.8945,
			width: 23.7752,
			height: 3.30211,
			rx: 1.65105,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.1797,
			y: 62.0469,
			width: 40.9767,
			height: 3.2013,
			rx: 1.60065,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50.1604,
			cy: 27.2453,
			rx: 1.66044,
			ry: 1.24533,
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.2607 18.7885C38.5893 18.2193 39.4108 18.2193 39.7393 18.7885L40.4624 20.0409C40.5443 20.1828 40.6652 20.2981 40.8109 20.3731L42.0261 20.9988C42.6432 21.3166 42.6432 22.199 42.0261 22.5168L40.8109 23.1425C40.6652 23.2175 40.5443 23.3328 40.4624 23.4747L39.7393 24.7272C39.4107 25.2963 38.5892 25.2963 38.2607 24.7272L37.5376 23.4747C37.4557 23.3328 37.3348 23.2175 37.1891 23.1425L35.9739 22.5168C35.3568 22.199 35.3568 21.3166 35.9739 20.9988L37.1891 20.3731C37.3348 20.2981 37.4557 20.1828 37.5376 20.0409L38.2607 18.7885Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.3984 67.3555L97.9685 72.0165",
			stroke: "#C9D8FC",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 101.078,
			y: 70.3008,
			width: 23.0645,
			height: 7.09676,
			rx: 1.77419,
			transform: "rotate(61.1281 101.078 70.3008)",
			fill: "#C9D8FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.925 40.8548C108.096 50.2328 104.687 62.0303 95.3048 67.2036C85.9226 72.3769 74.1262 68.9637 68.9553 59.5856C63.7843 50.2076 67.1937 38.4102 76.5759 33.2369C85.9582 28.0636 97.7545 31.4768 102.925 40.8548Z",
			fill: "white",
			fillOpacity: .5,
			stroke: "#C9D8FC",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.5211 43.8317C101.049 50.2291 98.722 58.2748 92.3246 61.8023",
			stroke: "#C9D8FC",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgSearchIllustration;
